import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const SpeciesCard = ({ species, onClick }) => {
  const getThreatColor = (level) => {
    const colors = {
      'Critical': 'bg-error text-error-foreground',
      'Endangered': 'bg-warning text-warning-foreground',
      'Vulnerable': 'bg-accent text-accent-foreground',
      'Stable': 'bg-success text-success-foreground'
    };
    return colors?.[level] || 'bg-muted text-muted-foreground';
  };

  const getTrendIcon = (trend) => {
    const icons = {
      'increasing': { name: 'TrendingUp', color: 'text-success' },
      'stable': { name: 'Minus', color: 'text-muted-foreground' },
      'decreasing': { name: 'TrendingDown', color: 'text-error' }
    };
    return icons?.[trend] || icons?.stable;
  };

  const trendIcon = getTrendIcon(species?.populationTrend);

  return (
    <div 
      onClick={onClick}
      className="bg-card rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic cursor-pointer group"
    >
      <div className="relative h-48 overflow-hidden">
        <Image
          src={species?.image}
          alt={species?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 animation-organic"
        />
        <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${getThreatColor(species?.threatLevel)}`}>
          {species?.threatLevel}
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-1">{species?.commonName}</h3>
            <p className="text-sm text-muted-foreground italic">{species?.scientificName}</p>
          </div>
          <Icon 
            name={trendIcon?.name} 
            size={20} 
            className={trendIcon?.color}
          />
        </div>

        <div className="grid grid-cols-2 gap-3 mt-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Population</p>
            <p className="text-sm font-medium text-foreground">{species?.population}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Last Survey</p>
            <p className="text-sm font-medium text-foreground">{species?.lastSurvey}</p>
          </div>
        </div>

        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-xs text-muted-foreground">Primary Threat</p>
          <p className="text-sm text-foreground mt-1">{species?.primaryThreat}</p>
        </div>
      </div>
    </div>
  );
};

export default SpeciesCard;